export const meta = {
  title: 'Penyelesaian masalah: bila ada yang tak kena',
  updatedAt: '2026-07-17',
  related: ['faq', 'notifications', 'billing'],
};

Empat perkara yang paling kerap dihadapi pengendali — gejala dahulu, kemudian apa yang perlu diperiksa dengan tepat.

## Pelanggan tidak boleh memasang aplikasi

- **Android (Chrome)** — butang **Pasang** muncul dalam aplikasi anda apabila pelayar membenarkannya. Jika pelanggan menolak gesaan pelayar sendiri, Chrome tidak akan menawarkannya lagi dalam sesi yang sama — menutup dan membuka semula pelayar mengembalikan butang itu.
- **iPhone (Safari)** — Apple tidak pernah memaparkan gesaan pemasangan. Aplikasi anda mengesan ini dan memaparkan tiga langkah manual: buka menu **Kongsi**, pilih **Tambah ke Skrin Utama**, sahkan.
- Apa pun, pemasangan adalah pilihan. Tempahan, status barisan langsung, dan pembayaran semuanya berfungsi dalam tab pelayar biasa.

## Notifikasi tidak sampai

Semak ikut senarai ini:

1. **Kebenaran** — pelanggan mesti telah membenarkan notifikasi apabila aplikasi bertanya (ia bertanya sejurus selepas tempahan). Jika mereka menyekatnya, pelayar mengingatinya: mereka perlu membenarkannya semula dalam tetapan pelayar untuk laman anda — aplikasi tidak boleh bertanya semula sendiri.
2. **iPhone** — notifikasi hanya berfungsi selepas aplikasi ditambah ke Skrin Utama; tab Safari biasa tidak menerima maklumat tolak.
3. **Jangkaan** — notifikasi keluar apabila tiket masuk barisan, mula dicuci, sedia, dibatalkan, atau ditangguhkan — berserta tahniah kenaikan tahap. **Tiada notifikasi semasa pengambilan** — notifikasi "resit" yang hilang bukan kerosakan; ia memang tidak wujud.
4. **Pemasaran khususnya** — penarikan diri dan waktu senyap (22:00–08:00 secara lalai) menelan notifikasi pemasaran secara senyap dan betul. Ringkasan siaran anda menamakan dengan tepat berapa yang dilangkau dan sebabnya.

## Pautan pembayaran luput

Dua kes berbeza:

- **Pelanggan membayar cucian dalam talian** — halaman pembayaran memang sekali guna dan berhayat pendek. Penyelesaiannya mudah: tekan **Bayar** sekali lagi — setiap tekanan mengeluarkan pautan baharu. Percubaan terbengkalai luput sendiri dan tidak pernah mengecaj sesiapa.
- **Invois langganan anda sendiri** — di halaman Bil, guna **Jana semula** di sebelah invois untuk mendapat pautan pembayaran baharu. Hanya pautan terbaharu boleh menyelesaikan invois; yang lama ditolak supaya tiada risiko caj berganda.

## Outlet saya tidak muncul di direktori awam

Periksa mengikut turutan ini:

1. **Suisnya** — _Papar outlet saya di direktori awam_, di bahagian bawah halaman Waktu, mesti dihidupkan. Ia mati secara lalai untuk setiap akaun baharu.
2. **Status outlet** — hanya outlet aktif disenaraikan. Outlet yang anda tutup atau buang tercicir dari direktori secara automatik.
3. **Masa** — perubahan mengalir dalam beberapa saat selepas disimpan. Matikan dan hidupkan semula suis untuk memaksa penyegaran jika anda mengesyaki gangguan.
4. **Kurasi** — rangkaian menyederhana direktori awam dan boleh menyembunyikan penyenaraian yang melanggar peraturannya. Jika anda percaya anda disembunyikan secara tersilap, tulis kepada kami melalui halaman Hubungi.

## Masih buntu?

Halaman **Hubungi** mencapai manusia sebenar dalam satu hari bekerja — dan talian WhatsApp di pengaki lebih pantas. Beritahu kami apa yang anda lihat dan apa yang anda jangkakan; tangkapan skrin sangat membantu.
